/* eslint-disable max-classes-per-file */
import { MeasuresItemData } from '../measuresItemData';
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';
// eslint-disable-next-line import/no-cycle
import { CustomAttributeData } from '../../customAttributes/customAttributes';
import { ModelRuleData } from '../../modelConfiguration/rules/modelRuleData';
import { ModelIlluminationData } from '../../modelIllumination/modelIlluminationData';
import { FileInformation } from '../fileInformation';

export class CatalogFileCollectionObjectInfo {
  metadataID = 0;
  sectionTitle = '';
  sectionInfo = '';
}

export class CatalogFileCollectionObjectTag {
  type = '';
  value = '';
}

export class CatalogFileCollectionObjectVersionControl {
  key = '';
  name = '';
  origin = '';
  revision = 0;
  binaryID = 0;
}

export class CatalogFileCollectionObject {

  id = 0;
  name = '';

  imageRef : string[] = [];

  infoRef = '';

  price = 0;
  priceCurrency = 0;

  displayPriority = '';

  objectInfo : CatalogFileCollectionObjectInfo[] = [];
  tags : CatalogFileCollectionObjectTag[] = [];

  versionControl = new CatalogFileCollectionObjectVersionControl();

  illumination : ModelIlluminationData | undefined;

  rules: ModelRuleData[] = [];
  measures: MeasuresItemData[] = [];
}

export class CatalogFileCollection {

  id = 0;
  name = '';

  imageRef : string[] = [];
  coverPictureIndex = -1;
  presentationPictureIndex = -1;

  objects : CatalogFileCollectionObject[] = [];
}

export class CatalogFileDisplayOptions {
  homePageType = 0;
  logoImagePath = '';
}

export class CatalogFileFilterTag {
  type = '';
  value = '';
}

export class CatalogFileFilter {
  name = '';
  tags : CatalogFileFilterTag[] = [];
}

export class CatalogFileSpotlightCollection {
  collectionId = 0;
}

export class CatalogFileSpotlightObject {
  collectionId = 0;
  objectId = 0;
}

export class CatalogFileSourceData {
  channelKey = '';
  channelName = '';
  channelEmail = '';
  channelExternalRef = '';
  channelBackendInsertOrderEndpoint = '';
  channelIsAuthenticationEnabled = false;

  catalogRevision = 0;
  catalogName = '';
  catalogKey = '';

  catalogExportKey = '';
}

export class CatalogFileCustomAttributesDefinition {
  attributes : CustomAttributeData[] = [];
}

export interface PriceData {
  model: string;
  group: string;
  option: string;
  price: number;
}

export class PriceDataHelpers {
  public static getPrice(
    priceData: PriceData[],
    model: string,
  ) : number | undefined {
    const price = priceData.find((p) => p.model === model && p.group === '' && p.option === '');
    return price?.price;
  }
  public static getOptionPrice(
    priceData: PriceData[],
    model: string,
    group: string,
    option: string,
  ) : number | undefined {
    // eslint-disable-next-line max-len
    const price = priceData.find((p) => p.model === model && p.group === group && p.option === option);
    return price?.price;
  }
  public static getOptionPriceData(
    priceData: PriceData[],
    model: string,
    group: string,
    option: string,
  ) : PriceData | undefined {
    // eslint-disable-next-line max-len
    const price = priceData.find((p) => p.model === model && p.group === group && p.option === option);
    return price;
  }
}

export class CatalogPriceFileRoot {
  priceDataInfo : PriceData[] = [];
}

export class CatalogFileRoot {

  constructor() {
    this.displayOptions = new CatalogFileDisplayOptions();
    this.sourceData = new CatalogFileSourceData();

    this.fileInformation = new FileInformation('mindsales_catalog', 1);
  }

  fileInformation : FileInformation;

  collections : CatalogFileCollection[] = [];
  priceData : PriceData[] | undefined = [];
  tagsTranslation : CatalogTagsTranslation[] = [];
  displayOptions : CatalogFileDisplayOptions;
  illuminationData : ModelIlluminationData | undefined;

  filters : CatalogFileFilter[] = [];

  spotlightCollections : CatalogFileSpotlightCollection[] = [];
  spotlightObjects : CatalogFileSpotlightObject[] = [];

  sourceData : CatalogFileSourceData;

  orderCustomAttributesDefinitions = new CatalogFileCustomAttributesDefinition();
  itemsCustomAttributesDefinitions = new CatalogFileCustomAttributesDefinition();

  name = '';
  key = '';
}

export class CatalogExport {

  public static CatalogInfoFileName = 'catalogInfo.json';

  constructor() {
    this.targetPath = '';
    this.catalogFileRoot = new CatalogFileRoot();
  }

  setTargetPath(targetPath : string) {
    this.targetPath = targetPath;
  }

  getCatalogFileData() : CatalogFileRoot {
    return this.catalogFileRoot;
  }

  targetPath : string;
  catalogFileRoot : CatalogFileRoot;
}

export class CatalogPriceExport {

  public static CatalogInfoFileName = 'catalogPriceInfo.csv';

  constructor() {
    this.targetPath = '';
    this.catalogPriceFileRoot = new CatalogPriceFileRoot();
  }

  setTargetPath(targetPath : string) {
    this.targetPath = targetPath;
  }

  getCatalogPriceFileData() : CatalogPriceFileRoot {
    return this.catalogPriceFileRoot;
  }

  targetPath : string;
  catalogPriceFileRoot : CatalogPriceFileRoot;
}
